import { ComponentsOverrides, Theme } from "@mui/material";

type MuiListItemButton = {
  styleOverrides: ComponentsOverrides<Theme>["MuiListItemButton"];
};

const muiListItemButton: MuiListItemButton = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        borderRadius: theme.shape.borderRadius,
        "&:has(.MuiTypography-body2)": {
          paddingTop: "6px",
          paddingBottom: "6px",
        },
      };
    },
  },
};

export default muiListItemButton;
